import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MainComponent } from './main/main.component';
import { HistoryComponent } from './history/history.component';
import { SettingsComponent } from './settings/settings.component';
import { AccountComponent } from './account/account.component';

import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { RegisterComponent } from './register/register.component';
import { ForgotComponent } from './forgot/forgot.component';
import { ResetComponent } from './reset/reset.component';

const routes: Routes = [

    {path: 'login/.', component: LoginComponent},
    {path: 'login/', component: LoginComponent},
    {path: 'logout/.', component: LogoutComponent},
    {path: 'logout/', component: LogoutComponent},
    {path: 'register/.', component: RegisterComponent},
    {path: 'register/', component: RegisterComponent},
    {path: 'forgot/.', component: ForgotComponent},
    {path: 'forgot/', component: ForgotComponent},
    {path: 'reset/.', component: ResetComponent},
    {path: 'reset/', component: ResetComponent},
    {path: '', component: MainComponent},
    {path: 'history/.', component: HistoryComponent},
    {path: 'history/', component: HistoryComponent},
    // { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
    {path: 'settings/.', component: SettingsComponent},
    {path: 'settings/', component: SettingsComponent},
    {path: 'account/.', component: AccountComponent},
    {path: 'account/', component: AccountComponent},
    {path: '**', redirectTo: '', pathMatch: 'full'},

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})

export class AppRoutingModule {
}
